export default {
  login: 'login', // 登录
  heartbeat: 'heartbeat', // 心跳
  enterWithOpenChatRoom: 'enterWithOpenChatRoom', // 加入房间
  exitChatRoom: 'exitChatRoom', // 退出房间
  updateQueue: 'updateQueue', //更新麦位 上麦
  pollQueue: 'pollQueue', //更新麦位 下麦
  sendMessage: 'sendMessage',
  sendText: 'sendText' // 房间发送消息
  // inviteToUser: 'inviteToUser',
  // closeChatRoom: 'closeChatRoom' // 用户已经开启语音房，再次开启视频房时，需要进行该处理。
}
